import {
  getGetProformaInvoiceKey,
  GetProformaInvoiceRequest,
  GetProformaInvoiceResponse,
} from "@/features/invoices/proforma-invoices/hooks/use-get-proforma-invoice";
import useFetcher from "@/utils/use-fetcher";
import { useMemo } from "react";
import { AxiosRequestConfig } from "axios";
import {
  GetDenseOrderDenseConfirmationInvoiceResponse,
  GetDenseProformaInvoiceRequest,
  parseGetDenseProformaInvoiceKey,
} from "@/features/invoices/proforma-invoices/hooks/use-get-dense-proforma-invoice";
import useCondenseOrderConfirmationInvoices from "@/features/invoices/order-confirmation-invoices/hooks/use-condese-order-confirmation-invoices";
import useCondenseOrderSheetSets from "@/features/order-sheet-sets/hooks/use-condense-order-sheet-sets";

export default function useGetDenseProformaFetcher() {
  const getProformaFetcher = useFetcher<
    GetProformaInvoiceRequest,
    GetProformaInvoiceResponse
  >();

  const condenseOrderConfirmationInvoices = useCondenseOrderConfirmationInvoices();
  const condenseOrderSheetSets = useCondenseOrderSheetSets();

  return useMemo(() => {
    return async (config: AxiosRequestConfig<GetDenseProformaInvoiceRequest>): Promise<GetDenseOrderDenseConfirmationInvoiceResponse> => {
      const { parameter, request } = parseGetDenseProformaInvoiceKey(config);

      const getProformaResponse = await getProformaFetcher(
        getGetProformaInvoiceKey(parameter, {})!
      );

      if (getProformaResponse) {
        const promises: Promise<void>[] = [
          condenseOrderConfirmationInvoices(
            [getProformaResponse],
            (i) => i.orderConfirmationInvoices,
            (item, value) => {
              if (Array.isArray(value)) {
                item.orderConfirmationInvoices = value;
              }
            },
            { by: parameter.by, companyId: parameter.companyId },
            // 오더를 건너뛰는 조회면 연결 OC 의 오더(+라인시트)도 채우지 않는다
            { skipOrderSheetSets: request?.skipOrderSheetSets }
          ),
        ];

        if (!request?.skipOrderSheetSets) {
          promises.push(
            condenseOrderSheetSets(
              [getProformaResponse],
              (i) => i.orderSheetSets,
              (item, value) => {
                if (Array.isArray(value)) {
                  item.orderSheetSets = value;
                }
              },
              { by: parameter.by, companyId: parameter.companyId }
            )
          );
        }

        await Promise.all(promises);
      }
      // @ts-ignore
      return Promise.resolve(getProformaResponse);
    };
  }, [
    getProformaFetcher,
    condenseOrderConfirmationInvoices,
    condenseOrderSheetSets,
  ]);
}
